import { RootState } from 'types'
import { Action } from 'redux/actions'
import { PropertyActions } from 'redux/actions/properties'

export default function reduce(
  state: RootState['highlightedPropNames'] = {},
  action: Action,
): RootState['highlightedPropNames'] {
  switch (action.type) {
    case PropertyActions.HIGHLIGHT_PROPERTIES: {
      const highlightedNames = action.payload
      return { ...state, ...highlightedNames }
    }

    default:
      return state
  }
}
